/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './landing.stache';
import dom from 'scripts/utils/dom';

Component.extend({
    tag: 'history-experience-landing',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            videoCanPlay: {
                type: 'boolean',
                value: false,
            },
            muted: {
                type: 'boolean',
                value: false,
            },
            renderVideo: {
                type: 'boolean',
                value: true,
            },
        },
    },
    events: {
        inserted() {
            this.initVideoEvents();
            dom.disableBounceEffect();
        },

        initVideoEvents() {
            this.player = this.element.find('brightcove-video').viewModel();
            this.player
                .on('videoerror', () => {
                    this.viewModel.attr('videoCanPlay', false);
                })
                .on('videoplaying', () => {
                    this.viewModel.attr('videoCanPlay', true);
                })
                .on('videopause', () => {
                    this.viewModel.attr('videoCanPlay', false);
                })
                .one('brightcoveready', () => {
                    this.intervalId = setInterval(
                        this.handleVideoPlayback.bind(this),
                        1000,
                    );
                });
        },

        handleVideoPlayback() {
            if (!this.viewModel.attr('muted')) {
                if (this.player.player.paused()) {
                    this.viewModel.attr('renderVideo', false);
                    this.viewModel.attr('muted', true);
                    this.viewModel.attr('renderVideo', true);
                    this.initVideoEvents();
                } else if (this.player.player.currentTime() > 0) {
                    clearInterval(this.intervalId);
                }
            } else {
                clearInterval(this.intervalId);
            }
        },
    },
});
